import {
  AlertIcon,
  Button,
  Flex,
  VStack,
  Skeleton,
  Text
} from "@chakra-ui/react";
import { useContext } from "react";

import { Alert } from "@/storybook-components/alert/alert";

import { ContributionContext } from "../context";

export function Budgeting() {
  const {
    showBudgeting,
    totalFund,
    isLoaded,
    fundLocale,
    hasTotalFunded,
    fundedForLocale,
    undoBudgetingLocale,
    handleBudgeting,
    isBudgetUpdating
  } = useContext(ContributionContext);

  if (!showBudgeting || !totalFund) return null;

  if (!isLoaded)
    return (
      <Skeleton borderRadius="md" h={{ base: "48px", xl: "40px" }} w="full" />
    );

  if (hasTotalFunded)
    return (
      <Alert
        borderRadius="md"
        status="success"
        variant="solid"
        h={{ base: "48px", xl: "40px" }}
      >
        <AlertIcon boxSize={{ base: "20px", xl: "16px" }} />
        <Flex flex="1" justifyContent="space-between">
          <Text fontSize={{ base: "md", xl: "md" }}>
            {fundedForLocale} {totalFund}
          </Text>
          <Button
            size="sm"
            variant="link"
            cursor="pointer"
            color="whiteAlpha"
            textDecoration="underline"
            isLoading={isBudgetUpdating}
            onClick={handleBudgeting}
          >
            {undoBudgetingLocale}
          </Button>
        </Flex>
      </Alert>
    );

  return (
    <VStack align="flex-end" w="full">
      <Button
        colorScheme="brand"
        size={{ base: "lg", xl: "md" }}
        onClick={handleBudgeting}
        w={{ base: "full", lg: "auto" }}
        isLoading={isBudgetUpdating}
      >
        {fundLocale} {totalFund}
      </Button>
    </VStack>
  );
}
